import styled from 'styled-components';

import { Link } from '../ui-helpers';
import { mediaSize } from '../../styles';


export const Card = styled.div`
  padding: 5px;
  border-radius: 12px;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 9px 24px 0 ${props => props.theme.colors.shadowSilver};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (min-width: ${mediaSize.desktop}) {
    padding: 80px 50px;
  }
  @media (max-width: ${mediaSize.tablet}) {
    svg {
      transform: scale(0.7);
    }
  }
  @media (max-width: ${mediaSize.phone}) {
    box-shadow: none;
  }
`;

export const ErrorPageWrap = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ isFullPage }) => isFullPage ? `
    height: 100vh;
  ` : `
    margin-top: 60px;
  `}
  @media (max-width: ${mediaSize.tablet}) {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  @media (max-width: ${mediaSize.phone}) {
    margin: 0;
  }
`;

export const ErrorPageContent = styled.div`
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  @media (min-width: ${mediaSize.desktop}) {
    margin-left: 30px;
  }
  @media (max-width: ${mediaSize.tablet}) {
    margin-top: 0px;
    margin-bottom: 20px;
  }
  @media (max-width: ${mediaSize.phone}) {
    padding: 5px 10px;
  }
`;

export const LinkButton = styled(Link)`
  padding: 18px 48px;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: .6px;
  font-weight: 300;
  margin-top: 15px;
  border-radius: 5rem;
  background: ${props => props.theme.colors.orangeColor};   
  text-decoration: none;
  color: ${props => props.theme.colors.white};
  
  &:focus,
  &:hover {
    text-decoration: none;  
    color: ${props => props.theme.colors.white};
  }
`;

export const Title = styled.div`
  font-weight: 700;
  line-height: 49px;
  color: ${props => props.theme.colors.darkColor};
  width: 100%;
  span {
    color: ${props => props.theme.colors.grayColor};
  }
  font-size: 40px;
`;

export const Description = styled.div`
  max-width: 400px;
  margin: 20px 0 35px;
  font-weight: 300;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: .68px;
  color: ${props => props.theme.colors.darkGrayColor};
  @media (max-width: ${mediaSize.tablet}) {
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/error-page/styles.js